import { defineStore } from 'pinia'
import Vue from 'vue'

export const useBankerStore = defineStore('betslipBanker', {
  state: () => ({
    // banker 开关
    bankerStatus: false,
    bankerMap: {}
  }),
  getters: {
    bankerTotalOdds() {
      return Object.values(this.bankerMap).reduce((sum, cur) => sum * cur.outcomeInfo.odds, 1)
    }
  },
  actions: {
    // 切换 banker 开关
    toggleBanker(status = false) {
      this.bankerStatus = status
    },
    setBanker({ id = '', status = true, selection }) {
      if (status) {
        Vue.set(this.bankerMap, id, selection)
      } else {
        Vue.delete(this.bankerMap, id)
      }
    }
  }
})
